module.exports = __webpack_public_path__ + "static/media/banner-keyman@3x.2abfb025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman@3x.png
// module id = 1256
// module chunks = 1